require('slick-carousel/slick/slick.css')
require('slick-carousel/slick/slick-theme.css')
require('slick-carousel/slick/slick')
require('infinite-scroll/dist/infinite-scroll.pkgd.min');

$(document).ready(function() {
    $('body').on('click', '.btn-choose-region', function () {
        const region = $(this).data('region')
        doChooseRegion(region)
        return false
    }).on('change', '.btn-select-region', function () {
        const region = $(this).val();
        doChooseRegion(region)
        return false
    }).on('click', '.btn-choose-cinema', function () {
        const cinema = $(this).data('cinema');
        doChooseCinema(cinema)
        return false
    }).on('change', '.btn-select-cinema', function () {
        const cinema = $(this).val();
        doChooseCinema(cinema)
        return false
    });

    $('#showtimes').on('click', '#dates .date', function () {
        var btn = $(this);
        params.date = btn.data('date');

        if (btn.hasClass('active') === false) {
            $('#dates .date').removeClass('active');
            btn.addClass('active');

            doGetShowtimes();
        }
        return false;
    });

    doChooseRegion(getRegion())
});

window.doChooseRegion = function (region) {
    $('.btn-select-region').val(region)
    $('.btn-choose-region').removeClass('active')
    $('.btn-choose-region[data-region="' + region + '"]').addClass('active')

    doGetCinemas(region);
}

window.doChooseCinema = function (cinema) {
    if (params.id !== cinema) {
        $('.btn-select-cinema').val(cinema)
        $('.btn-choose-cinema').removeClass('active')
        $('.btn-choose-cinema[data-cinema="' + cinema + '"]').addClass('active')

        params.id = cinema
        setCinema(params.id)
        doGetShowtimes()
    }
}

window.doGetCinemas = function (region) {
    let baseUri = process.env.MOVEEK_API_ENDPOINT;
    const ticketing = params.ticketing;
    let url = baseUri + '/v1/cinemas?page=1&page_size=100&order%5Bname%5D=ASC&region_id=' + region + '&status=publish&closed=0&opening_soon=0'
    if (ticketing === 1) {
        url += '&ticketing=1&extended=1'
    }

    setRegion(region);
    $('#blockCinemas .list').html('<div class="text-center pt-4 pb-4"> <div class="text-muted spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>');
    $('#blockCinemas .btn-select-cinema').html('<option value="">' + Translator.trans('label.loading') + '</option>')

    let data = {}
    $.getJSON(url, function (response) {
        $.each(response, function (k, cinema) {
            let cineplex = cinema['cineplex']
            if (cineplex === null) {
                cineplex = {
                    id: 0,
                    name: 'Khác',
                    slug: 'khac',
                    logo: {
                        sizes: {
                            tiny: '/images/logo-cineplex.png'
                        }
                    }
                }
            }

            if (typeof data[cineplex.id] === 'undefined') {
                data[cineplex.id] = {
                    cineplex: cineplex,
                    cinemas: []
                }
            }

            data[cineplex.id].cinemas.push(cinema);
        })

        // sort data by cineplex.sponsored (true first), then by cineplex.name, and place cineplex.id = 0 last
        data = Object.values(data).sort((a, b) => {
            if (a.cineplex.id === 0) return 1; // place cineplex.id = 0 last
            if (b.cineplex.id === 0) return -1; // place cineplex.id = 0 last
            if (b.cineplex.sponsored - a.cineplex.sponsored !== 0) {
                return b.cineplex.sponsored - a.cineplex.sponsored; // sort by sponsored
            }
            return a.cineplex.name.localeCompare(b.cineplex.name); // sort by name
        });

        let html = '<div>';
        let options = '<option value="">' + Translator.trans('label.choose_cinema') + '</option>';
        $.each(data, function (k, d) {
            html += '<a href="#" class="list-group-item list-group-item-action disabled bg-light"><img src="' + d.cineplex?.logo?.sizes?.tiny + '" alt="" class="rounded-circle float-left mr-3" width="24">' + d.cineplex.name + '</a>';
            options += '<optgroup label="' + d.cineplex.name + '">';
            $.each(d.cinemas, function (i, cinema) {
                html += '<a href="#" class="list-group-item list-group-item-action text-truncate btn-choose-cinema" data-cinema="' + cinema.id + '">' + cinema.name + '</a>';
                options += '<option value="' + cinema.id + '">' + cinema.name + '</option>';
            });
            options += '</optgroup>';
        })

        html += '</div>';

        $('#blockCinemas .list').html(html);
        $('#blockCinemas .btn-select-cinema').html(options);

        doAutoSelectCinema();
    });

    return false;
}

window.doGetShowtimes = function() {
    if (params.id) {
        $('#showtimes').html('<div class="text-center mb-3"> <div class="text-muted spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>');
        $.ajax({
            url : generateRouteUrl('orn_web_cinema_showtime', { id : params.id, date : params.date, header : params.header }),
            success : function(data) {
                $('#showtimes').html(data);
                doGetShowtimePrice(data);
                appendUtmToAffiliateLinks()
            }
        });
    }
    else {
        $('#showtimes').html('<div class="alert alert-light">Bạn chưa chọn rạp.</div>');
    }
}

window.doAutoSelectCinema = function() {
    var cinema = getCinema();
    if (cinema !== '') {
        doChooseCinema(cinema)
    }
}
